<template>
  <div id="Specificationone">
    <!-- <Head v-if="!CompanyID" /> -->
    <div class="Specification clear">
      <!-- <Nav ms="/Specificationone" v-if="!CompanyID" /> -->
      <div class="H-right">
        <div class="title">单位统计指标</div>
        <!-- <div class="H-header"> -->
        <!-- <div class="t-left">
            <select class="show-parent" @click="DropdownShow1">
              <option style="display:none">{{companyName}}</option>
            </select>
            <Dropdown
              @item-click="childFn"
              @item-click1="childFn1"
              class="Dropdown"
              :show="DropdownShow"
              :placeholder="placeholder"
              :itemlist="companyvalue"
              :nodatatext="nodatatext"
            />
        </div>-->
        <!-- </div> -->
        <div v-if="showTable">
          <div class="t-left">
            <input
              type="text"
              placeholder="请输入要查询企业名称"
              v-model="companyName"
            />
            <select name id v-model="cWstatus" @change="getcompanyList">
              <option value>请选择财务指标状态</option>
              <option value="0">未填写</option>
              <option value="1">已上报</option>
              <option value="2">已退回</option>
            </select>
            <select name id v-model="zYstatus" @change="getcompanyList">
              <option value>请选择专业指标状态</option>
              <option value="0">未填写</option>
              <option value="1">已上报</option>
              <option value="2">已退回</option>
            </select>
          </div>
          <el-table
            border
            :header-cell-style="{
              'background-color': '#001743',
              color: '#fff',
              height: '0.5rem',
            }"
            style="width: 12rem"
            :data="tableDatas"
            :row-style="{ height: '0.4rem' }"
          >
            <el-table-column
              type="index"
              label="序号"
              width="60"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="Name"
              label="企业名称"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="Manager"
              width="100"
              label="联系人"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="Phone"
              width="150"
              label="手机号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="tyzb"
              width="130"
              :label="label"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="zyzb"
              width="130"
              :label="label1"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="100"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="medium"
                  @click="getdata((companyvalue = scope.row.ID))"
                  >查看</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="text-align: right; height: 0.45rem"
            v-show="showTable"
            @current-change="CurrentChange1"
            @size-change="handleSizeChange1"
            :current-page="Page1"
            :page-size="PageSize1"
            :page-sizes="[10, 20, 30]"
            layout="total,sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
        <div v-else>
          <!-- <el-button
            type="primary"
            size="medium"
            v-if="!CompanyID"
            @click="showTable = !showTable"
            style="margin-bottom: 0.2rem"
            >返回</el-button
          >
          <el-button
            type="primary"
            size="medium"
            @click="SpFn"
            v-else
            style="margin-bottom: 0.2rem"
            >返回</el-button
          > -->
          <div class="t_main">
            <div class="f_title">财务指标列表</div>
            <el-table
              border
              :header-cell-style="{
                'background-color': '#001743',
                color: '#fff',
                height: '0.5rem',
              }"
              :data="tableData"
              style="width: 12rem"
              :row-style="{ height: '0.4rem' }"
            >
              <el-table-column
                label="序号"
                header-align="center"
                align="center"
                width="100"
                type="index"
              ></el-table-column>
              <el-table-column
                prop="Year"
                label="数据年份"
                header-align="center"
                align="center"
                width="300"
              ></el-table-column>
              <el-table-column
                prop="Status"
                label="填写状态"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.Status == 0
                    ? "未填写"
                    : scope.row.Status == 2
                    ? "已退回"
                    : "已上报"
                }}</template>
              </el-table-column>
              <el-table-column label="操作" header-align="center" align="left">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    style="
                      background: rgb(45, 101, 210);
                      color: #ffffff;
                      margin-left: 1rem;
                    "
                    @click="Del(scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    size="mini"
                    style="background: rgb(243, 37, 47); color: #ffffff"
                    v-show="scope.row.Status == 1"
                    @click="sendBack(scope.row)"
                    >退回</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="t_main">
            <div class="f_title">专业指标列表</div>
            <el-table
              border
              :header-cell-style="{
                'background-color': '#001743',
                color: '#fff',
                height: '0.5rem',
              }"
              :data="tableData1"
              style="width: 12rem"
              :row-style="{ height: '0.4rem' }"
            >
              <el-table-column
                label="序号"
                header-align="center"
                align="center"
                width="100"
                type="index"
              ></el-table-column>
              <el-table-column
                prop="Year"
                label="数据年份"
                header-align="center"
                align="center"
                width="300"
              ></el-table-column>
              <el-table-column
                prop="Status"
                label="填写状态"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.Status == 0
                    ? "未填写"
                    : scope.row.Status == 2
                    ? "已退回"
                    : "已上报"
                }}</template>
              </el-table-column>
              <el-table-column label="操作" header-align="center" align="left">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    style="
                      background: rgb(45, 101, 210);
                      color: #ffffff;
                      margin-left: 1rem;
                    "
                    @click="Del1(scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    size="mini"
                    style="background: rgb(243, 37, 47); color: #ffffff"
                    @click="sendBack(scope.row)"
                    v-show="scope.row.Status == 1"
                    >退回</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="t_write" v-if="show">
          <div class="write">
            <p>{{ yearstr + "财务统计指标" }}</p>
            <i class="cancel" @click="cancel"></i>
            <div class="info">
              <div
                v-for="(item, index) in name"
                :key="index"
                :ref="'changetext' + index"
              >
                <span>{{ item.name }}</span>
                <!-- <input v-model="content[index].value" type="text"  v-if="Status==0" /> -->
                <span class="readonly" :title="content[index].value">{{
                  content[index].value | sLen
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="t_write" v-if="show1">
          <div class="write">
            <p>{{ yearstr + "专业统计指标" }}</p>
            <i class="cancel" @click="cancel1"></i>
            <div class="info">
              <div
                v-for="(item, index) in name1"
                :key="index"
                :ref="'changetext' + index"
              >
                <span>{{ item.name }}</span>
                <!-- <input v-model="content1[index].value" type="text" v-if="Status==0"  /> -->
                <span class="readonly" :title="content1[index].value">{{
                  content1[index].value | sLen
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Foot v-if="!CompanyID" />
  </div>
</template>

<script>
// import Head from "../../components/BackHead";
import Foot from "../../components/Foot";
// import Nav from "../../components/BackNav";
// import Dropdown from "../../components/Dropdown";
export default {
  data() {
    return {
      tableData: [],
      tableData1: [],
      tableDatas: [],
      name: [],
      name1: [],
      content: [],
      content1: [],
      yearstr: "",
      companyvalue: [],
      companyVal: "",
      //write:['1、营业收入','2、利润总额','3、净利润','4、资产总额','5、负债总额','6、所有者权益总额','7、海外收入','8、海外资产','9、纳税总额','10、研发费用','11、从业人员','12、从业人员人均年收入','13、安全生产费用'],
      // type1:['1、营业收入','2、利润总额','3、净利润','4、资产总额','5、负债总额','6、所有者权益总额','7、海外收入','8、海外资产','9、纳税总额','10、研发费用','11、从业人员','12、从业人员人均年收入','13、安全生产费用'],
      DropdownShow: false,
      placeholder: "请输入要查询的公司",
      nodatatext: "查无结果",
      show: false,
      show1: false,
      Status: "",
      ces: "33",
      companyName: "",
      userinfo: {},
      showTable: true,
      Page1: 1,
      PageSize1: 30,
      total: "",
      zYstatus: "",
      cWstatus: "",
      time: "",
    };
  },
  props: {
    CompanyID: {
      type: String,
    },
  },
  computed: {
    label() {
      var nowDate = new Date();
      return "财务指标状态\n（" + (nowDate.getFullYear() - 1) + "）";
    },
    label1() {
      var nowDate = new Date();
      return "专业指标状态\n（" + (nowDate.getFullYear() - 1) + "）";
    },
  },
  mounted() {
    this.hideBox();
    console.log(this.CompanyID);
    !this.CompanyID ? this.getcompanyList() : this.getdata(this.CompanyID);
  },

  created() {
    // this.getdata();
    this.getcompany();
  },

  methods: {
    SpFn() {
      this.$emit("child-quit");
    },
    CurrentChange1(val) {
      //console.log(val)
      this.Page1 = val;
      this.getcompanyList();
    },
    handleSizeChange1(val) {
      //console.log(val)
      this.PageSize1 = val;
      this.getcompanyList();
    },
    getcompanyList() {
      this.$axios
        .post(
          "statistic/alllist?token=" + sessionStorage.getItem("token"),
          this.$qs.stringify({
            tyzbStatus: this.cWstatus,
            zyzbStatus: this.zYstatus,
            names: this.companyName,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            console.log(res.data.data);
            this.tableDatas = res.data.data;
            this.tableDatas.forEach((val) => {
              // if(val.zyzb==0){
              //   val.zyzb="未填写"
              // }else if(val.zyzb==1){
              //   val.zyzb
              // }
              val.zyzb == 0
                ? (val.zyzb = "未填写")
                : val.zyzb == 1
                ? (val.zyzb = "已上报")
                : val.zyzb == 2
                ? (val.zyzb = "已退回")
                : (val.zyzb = "无");
              val.tyzb == 0
                ? (val.tyzb = "未填写")
                : val.tyzb == 1
                ? (val.tyzb = "已上报")
                : val.tyzb == 2
                ? (val.tyzb = "已退回")
                : (val.tyzb = "无");
            });
            this.total = res.data.data.length;
            var st = (this.Page1 - 1) * this.PageSize1;
            this.tableDatas = this.tableDatas.slice(
              this.Page1 == 1 ? 0 : st,
              this.PageSize1 * this.Page1
            );
          } else {
            this.$message({
              type: "warning",
              message: res.data.msg,
            });
          }
        });
    },
    sendBack(index) {
      console.log(index);
      let that = this;
      this.$confirm("确认退回操作, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$axios
            .post(
              "Statistic/upStatus?Status=2&ID=" +
                index.ID +
                "&token=" +
                sessionStorage.getItem("token")
            )
            .then((res) => {
              if (res.data.code == 10000) {
                this.$message({
                  type: "info",
                  message: "退回成功",
                });
                that.getdata();
              } else {
                this.$message({
                  type: "info",
                  message: "操作失败",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    childFn(arr) {
      console.log(arr);
      this.companyVal = arr.Company;
      this.companyName = arr.Name;
      this.getdata();
    },
    DropdownShow1() {
      this.DropdownShow = true;
      console.log(11111);
      console.log(this.DropdownShow);
    },
    childFn1(br) {
      console.log(br);
      this.DropdownShow = br;
    },
    // childFn1(data) {
    //   this.DropdownShow = false;
    //   console.log(data);
    // },
    hideBox() {
      document.addEventListener("click", (e) => {
        // 如果当前点击的这个对象是这个模态框的话
        if (e.target.closest(".show-parent")) {
          //  那么这个模态框还是显示的
          this.DropdownShow = true;
        } else if (!e.target.closest(".Dropdown")) {
          // 如果当前点击的这个对象是这个show按钮以外的对象，那么这个模态框就隐藏
          this.DropdownShow = false;
        }
        // else if(!e.target.closest(".Dropdown")){
        //     this.DropdownShow=false
        // }
      });
    },
    DropdownShowFn() {
      this.DropdownShow = true;
    },
    getcompany() {
      var that = this;
      that.$axios
        .post(
          "Statistic/Selectcompanyvalue?token=" +
            sessionStorage.getItem("token"),
          that.$qs.stringify({
            //:this.restatus
          })
        )
        .then((res) => {
          console.log(res.data.data, 67);
          if (res.data.code == 10000) {
            this.companyvalue = res.data.data;
          }
        });
    },
    getdata(id) {
      var that = this;
      console.log(this.companyVal, 111);
      if (id) {
        this.companyVal = id;
        this.showTable = !this.showTable;
      } else {
        this.getcompanyList();
      }
      that.$axios
        .post(
          "Statistic/SelectStatic?token=" + sessionStorage.getItem("token"),
          that.$qs.stringify({
            companyID: this.companyVal,
          })
        )
        .then((res) => {
          console.log(res.data.data, 111);
          if (res.data.code == 10000) {
            this.tableData = res.data.data.list;
            this.tableData1 = res.data.data.list1;
            // this.tableData1=this.tableData1.splice(0,5)
            this.name = res.data.data.name;
            this.name1 = res.data.data.name1;
            //this.total = res.data.data.total_num;
            this.content = [];
            this.content1 = [];
            console.log(this.name);
            for (var i = 0; i < this.name.length; i++) {
              var item = { Title: this.name[i]["Code"], value: "" };
              this.content.push(item);
            }

            console.log(this.content);
            //this.content1.splice(0);
            for (var j = 0; j < this.name1.length; j++) {
              var item1 = { Title: this.name1[j]["Code"], value: "" };
              this.content1.push(item1);
            }
            console.log(this.content1);
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },

    flexColumnWidth(str) {
      let flexWidth = 0;
      for (const char of str) {
        if ((char >= "A" && char <= "Z") || (char >= "a" && char <= "z")) {
          // 如果是英文字符，为字符分配8个单位宽度
          flexWidth += 8;
        } else if (char >= "\u4e00" && char <= "\u9fa5") {
          // 如果是中文字符，为字符分配20个单位宽度
          flexWidth += 20;
        } else {
          // 其他种类字符，为字符分配5个单位宽度
          flexWidth += 5;
        }
      }
      if (flexWidth < 50) {
        // 设置最小宽度
        flexWidth = 200;
      }
      if (flexWidth > 250) {
        // 设置最大宽度
        flexWidth = 250;
      }
      return flexWidth + "px";
    },
    Del(a) {
      this.StatisticID = a.ID;
      console.log(this.StatisticID, 666);
      let that = this;
      that.$axios
        .post(
          "StatisticContent/index?StatisticID=" +
            that.StatisticID +
            "&token=" +
            sessionStorage.getItem("token")
        )
        .then((res) => {
          console.log(res.data, 2232);
          if (res.data.code == 10000) {
            if (res.data.data.list.length == 0) {
              for (var i1 = 0; i1 < this.content.length; i1++) {
                this.content[i1]["value"] = "";
                // console.log(this.content,1333);
              }
            } else {
              for (var i = 0; i < res.data.data.list.length; i++) {
                this.content[i]["value"] = res.data.data.list[i]["Content"];
                // console.log(this.content,1333);
              }
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
      this.show = true;
      this.Status = a.Status;
      this.yearstr = a.Year;
    },
    Del1(a) {
      this.show1 = true;
      this.Status = a.Status;
      this.yearstr = a.Year;
      this.StatisticID = a.ID;
      let that = this;
      that.$axios
        .post(
          "StatisticContent/index?StatisticID=" +
            that.StatisticID +
            "&token=" +
            sessionStorage.getItem("token")
        )
        .then((res) => {
          if (res.data.code == 10000) {
            if (res.data.data.list.length == 0) {
              for (var j1 = 0; j1 < this.content1.length; j1++) {
                this.content1[j1]["value"] = "";
                // console.log(this.content,1333);
              }
            } else {
              for (var j = 0; j < res.data.data.list.length; j++) {
                this.content1[j]["value"] = res.data.data.list[j]["Content"];
                // console.log(this.content,1333);
              }
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        });
    },
    cancel() {
      this.show = false;
    },
    cancel1() {
      this.show1 = false;
    },
  },

  watch: {
    companyName: function() {
      clearTimeout(this.time);
      this.time = setTimeout(() => {
        this.getcompanyList();
      }, 1000);
    },
  },
  filters: {
    sLen(val) {
      if (val.length > 25) {
        val = val.slice(0, 20) + "...";
      }
      return val;
    },
  },
  components: {
    // Head,
    Foot,
    // Nav,
    // Dropdown
  },
};
</script>

<style lang="less" scoped>
.clear:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.btn {
  width: 1rem;
  cursor: pointer;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.17rem;
  text-align: center;
  background: #409eff;
  border-radius: 0.04rem;
  color: #fff;
}

.Specification {
  width: 100%;
  min-width: 1000px;
  font-size: 0.16rem;
  // padding: 0.28rem 2.54rem;
  box-sizing: border-box;

  .H-right {
    position: relative;
    width: 11.5rem;
    min-width: 750px;
    padding-left: 0.2rem;
    height: 100%;
    float: right;
    min-height: 9.4rem;
    position: relative;

    .t-left {
      input,
      select {
        padding: 0.01rem 0 0.01rem 0.05rem;
        height: 0.4rem;
        width: 2rem;
        margin-bottom: 0.1rem;
        margin-right: 0.2rem;
      }
    }

    .title {
      font-size: 0.4rem;
      margin: 0.2rem 0 0.5rem;
      text-align: center;
    }
  }

  .btnselect {
    display: flex;
  }

  .H-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 0.5rem;

    .t-left {
      // display: flex;
      // justify-content: space-around;
      // align-items: center;
      height: 0.5rem;

      .Dropdown {
        position: absolute;
        left: 0;
        top: 0.25rem;
        width: 100%;
      }

      > input,
      > div,
      select {
        margin-right: 0.2rem;
      }

      input,
      select {
        height: 0.4rem;
        padding: 0.05rem;
        width: 2.8rem;
      }
    }
  }

  .t_main {
    margin-bottom: 0.4rem;

    .f_title {
      margin-bottom: 0.2rem;
      color: #1c1c1c;
      font-size: 0.2rem;
      font-weight: 700;
    }
  }

  .t_write {
    background: rgba(10, 10, 10, 0.3);
    padding: 0.77rem 0.7rem;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10000;

    .write {
      background: #fff;
      padding: 0.3rem 0.45rem;
      position: relative;

      p {
        font-size: 0.3rem;
        color: #0d0d0d;
        text-align: center;
        margin-bottom: 0.52rem;
      }

      .cancel {
        width: 0.25rem;
        height: 0.25rem;
        display: block;
        background: url("../../assets/back/x.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 0.3rem;
        top: 0.3rem;
      }

      .info {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .readonly {
          width: 2rem;
          height: 0.35rem;
          border: 0.01rem solid #ccc;
          margin: 0;
          line-height: 0.35rem;
          padding: 0 0.1rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          box-shadow: 0 2px 12px -2px rgba(0, 0, 0, 0.1);
        }

        div {
          width: 43%;
          margin-bottom: 0.46rem;
          display: flex;
          align-items: center;

          span {
            display: inline-block;
            width: 1.05rem;
            margin-right: 0.1rem;
          }

          input {
            width: 2rem;
            height: 0.35rem;
            margin-right: 0.1rem;
          }
        }
      }

      .btn {
        margin: 0 auto;
        background: #2d65d2;
        width: 3.15rem;
        height: 0.55rem;
        line-height: 0.55rem;
        font-size: 0.24rem;
        border-radius: 0.08rem;
      }
    }
  }
}
</style>
